import { connect } from 'react-redux'
import { compose } from 'redux'
import { reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core'
import { createStructuredSelector } from 'reselect'

import { CreateUserFormBase } from './CreateUserForm'

import { userActions } from 'reduxModules/actions/UserActions'
import { isLoadingSelector } from 'reduxModules/selectors/UserSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  isLoading: isLoadingSelector
})

const mapDispatchToProps = {
  createUser: userActions.createUser
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'createUser'
  }),
  withStyles(styles)
)

export const CreateUserForm = enhance(CreateUserFormBase)



// WEBPACK FOOTER //
// ./src/components/Users/components/CreateUserForm/index.js